import {
  get
} from 'lodash';
import * as types from '../constants/actions';

export const INITIALSTATE = [];

export default (state = INITIALSTATE, action) => {
    switch (action.type) {
        case types.INIT_REF:
            return [...state, action.payload];

        // REMOVE_* Removes the entire record
        case types.REMOVE_REF:
            return state.filter((change) => change.ref !== action.payload.ref);

        case types.REMOVE_REFS:
            return INITIALSTATE;

        case types.UPDATE_CHANGE_ID:
            return state.map((change) => {
                if (change.ref === action.payload.ref) {
                    return {
                        ...change,
                        id: action.payload.id
                    };
                }
                return change;
            });

        case types.UPDATE_REQUIRED_CHANGES:
            return state.map((change) => {
                if (change.ref === action.payload.ref) {
                    return {
                        ...change,
                        required: action.payload.required
                    };
                }

                return change;
            });

        case types.ADD_PENDING_CHANGES:
            return state.map((change) => {
                if (change.ref === action.payload.ref) {
                    return {
                        ...change,
                        changes: {
                            ...change.changes,
                            ...action.payload.changes
                        }
                    };
                }
                return change;
            });

        // CLEAR_PENDING_* Will remove the pending changes but leave the record
        case types.CLEAR_PENDING_CHANGE:
            return state.map((change) => {
                if (change.ref === action.payload.ref) {
                    return {
                        ...change,
                        changes: {}
                    };
                }

                return change;
            });

        case types.CLEAR_PENDING_CHANGES:
            return state.map((change) => ({
                ...change,
                changes: {}
            }));

        case types.VALIDATION_ADD_ERROR:
            return state.map((change) => {
            if (change.ref === action.payload.ref) {
                const existingErrors = get(change, `validation.${action.payload.field}`, []);
                const val = {
                    [action.payload.field]: [...existingErrors, ...action.payload.errors]
                };

                return {
                    ...change,
                    validation: {
                        ...change.validation,
                        ...val
                    }
                };
            }
            return change;
        });

        case types.VALIDATION_CLEAR_ERRORS:
            return state.map((change) => ({
                ...change,
                validation: {}
            }));

        default:
            return state;
    }
}

export const getChangeCount = (state) => state.portal.changes.reduce((m, c) => m + Object.keys(c.changes || {}).length, 0);
export const getErrorCount = (state) => state.portal.changes.reduce((m, c) => m + Object.keys(c.validation || {}).length, 0);

export const getChanges = (state, ref) => {
    return state.portal.changes.find((change) => change.ref === ref);
};

export const getChangesValidation = (state, ref, field) => {
    return get(getChanges(state, ref), `validation.${field}`, []);
};
